import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const SORTS = [
  { v: "new", l: "Newest" },
  { v: "price_asc", l: "Price: Low to High" },
  { v: "price_desc", l: "Price: High to Low" },
];

export default function Shop() {
  const { category } = useParams();
  const loc = useLocation();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState("new");

  const params = useMemo(() => {
    const sp = new URLSearchParams(loc.search);
    const p = Object.fromEntries(sp.entries());

    if (category) {
      p.category = category;
    }

    return p;
  }, [loc.search, category]);

  useEffect(() => {
    let mounted = true;

    setLoading(true);

    api
      .get("/products", {
        params,
      })
      .then((response) => {
        console.log("JEWELS ASHU PRODUCTS:", response.data);

        if (mounted) {
          setItems(
            Array.isArray(response.data)
              ? response.data
              : []
          );
        }
      })
      .catch((error) => {
        console.error(
          "JEWELS ASHU PRODUCTS ERROR:",
          error
        );

        if (mounted) {
          setItems([]);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [params]);

  const sorted = useMemo(() => {
    const a = [...items];

    if (sort === "price_asc") {
      a.sort((x, y) => x.price - y.price);
    }

    if (sort === "price_desc") {
      a.sort((x, y) => y.price - x.price);
    }

    return a;
  }, [items, sort]);

  const title =
    params.category ||
    params.metal ||
    params.gemstone ||
    params.occasion ||
    "All Jewellery";

  return (
    <div
      className="ja-container py-16 md:py-24"
      data-testid="shop-page"
    >
      <div className="text-center mb-16">
        <p className="ja-overline">Collection</p>

        <h1 className="ja-serif text-5xl md:text-6xl mt-3 tracking-tight">
          {title}
        </h1>
      </div>

      <div
        className="flex items-center justify-between border-y py-4 mb-12"
        style={{ borderColor: "var(--ja-border)" }}
      >
        <p
          className="text-sm"
          style={{ color: "var(--ja-muted)" }}
        >
          {sorted.length} pieces
        </p>

        <select
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="bg-transparent text-xs tracking-[0.2em] uppercase outline-none cursor-pointer"
          data-testid="sort-select"
        >
          {SORTS.map((s) => (
            <option key={s.v} value={s.v}>
              {s.l}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="aspect-[4/5] bg-white/70" />

              <div className="h-3 mt-4 bg-white/70 w-2/3 mx-auto" />

              <div className="h-3 mt-2 bg-white/70 w-1/3 mx-auto" />
            </div>
          ))}
        </div>
      ) : sorted.length === 0 ? (
        <div className="text-center py-20">
          <p className="ja-serif text-2xl">
            Nothing here, yet.
          </p>

          <Link
            to="/shop"
            className="ja-btn-outline mt-8"
            data-testid="shop-empty-back"
          >
            Browse All
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-16">
          {sorted.map((p, i) => (
            <ProductCard
              key={p.id}
              p={p}
              idx={i}
            />
          ))}
        </div>
      )}
    </div>
  );
}
